import { Injectable, NgZone } from '@angular/core';

type TimerEntry = {
  handle: ReturnType<typeof setInterval>;
  callbacks: Set<() => void>;
};

@Injectable({
  providedIn: 'root',
})
export class SimpleTimer {
  private readonly timers = new Map<string, TimerEntry>();

  constructor(private zone: NgZone) {}

  public newTimer(timerId: string, seconds: number): void {
    if (this.timers.has(timerId)) {
      return;
    }

    const intervalMs = Math.max(1, Number(seconds || 1)) * 1000;
    const entry: TimerEntry = {
      handle: null as unknown as ReturnType<typeof setInterval>,
      callbacks: new Set<() => void>(),
    };

    entry.handle = setInterval(() => {
      this.zone.run(() => {
        entry.callbacks.forEach((callback) => callback());
      });
    }, intervalMs);

    this.timers.set(timerId, entry);
  }

  public subscribe(timerId: string, callback: () => void): void {
    if (!this.timers.has(timerId)) {
      this.newTimer(timerId, 1);
    }
    this.timers.get(timerId)?.callbacks.add(callback);
  }

  public unsubscribe(timerId: string): void {
    this.timers.get(timerId)?.callbacks.clear();
  }

  public delTimer(timerId: string): void {
    const entry = this.timers.get(timerId);
    if (!entry) {
      return;
    }
    clearInterval(entry.handle);
    this.timers.delete(timerId);
  }

  public getTimer(): string[] {
    return Array.from(this.timers.keys());
  }
}
